import React, { useState } from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import { Form, Button } from "react-bootstrap"
import { useLocation, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { resetPassword } from "../../data/authenticationSlice"
import Loader from "../../components/Loader"

const CompleteRegistration = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const identityCode = location?.pathname?.split("/")?.[2]
    const code = location?.pathname?.split("/")?.[3]

    const { fetchStatus } = useSelector((state) => state.authentication)

    const [formData, setFormData] = useState({
        password: "",
        confirmPassword: ""
    })

    const [errors, setErrors] = useState({ password: null, confirmPassword: null, standardError: null })

    const handleChange = (event) => {
        const { name, value } = event.target
        setFormData({
            ...formData,
            [name]: value
        })
    }

    const validateForm = () => {
        let errors = {}
        // Check if password is at least 6 characters
        if (formData?.password.length < 6) {
            errors.password = "Password must be at least 6 characters"
        }

        // Check if password has at least one non-alphanumeric character
        if (!/\W/.test(formData?.password)) {
            errors.nonAlphanumeric = "Password must have at least one non-alphanumeric character"
        }

        // Check if password has at least one lowercase letter
        if (!/[a-z]/.test(formData?.password)) {
            errors.lowercase = "Password must have at least one lowercase letter"
        }

        // Check if password has at least one uppercase letter
        if (!/[A-Z]/.test(formData?.password)) {
            errors.uppercase = "Password must have at least one uppercase letter"
        }

        if (
            !formData?.password ||
            !formData?.confirmPassword ||
            formData?.confirmPassword !== formData?.password ||
            Object.keys(errors).length > 0
        ) {
            setErrors({
                ...errors,
                confirmPassword:
                    formData?.password && formData?.confirmPassword !== formData?.password
                        ? "The passwords don't match"
                        : ""
            })
            return false
        } else {
            setErrors({})
            return true
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault()

        if (validateForm() && identityCode && code) {
            dispatch(resetPassword({ ...formData, identityCode, code })).then(({ payload }) => {
                if (payload?.succeeded) {
                    navigate("/agency/login", {
                        state: {
                            message: "Your password has been set, please log in."
                        }
                    })
                } else if (!payload?.succeeded && payload?.errorMessage) {
                    setErrors((preErrors) => ({
                        ...preErrors,
                        standardError: payload?.errorMessage
                    }))
                }
            })
        } else if (validateForm() && (!identityCode || !code)) {
            setErrors({
                urlError: "The URL is missing necessary tokens. Please revisit the page with a valid URL."
            })
        }
    }

    return (
        <div className="container d-flex justify-content-center align-items-center vh-100">
            <Loader show={fetchStatus === "loading"} />
            <div
                style={{ backgroundColor: "#FFF" }}
                className="col-md-5 auth-box">
                <h1 className="text-center mb-4">Create Your Password</h1>
                <Form onSubmit={handleSubmit}>
                    <Form.Group
                        controlId="password"
                        className="pt-2">
                        <Form.Label>
                            Password<span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            placeholder="Enter Password"
                        />
                    </Form.Group>
                    <Form.Group
                        controlId="confirmPassword"
                        className="pt-2">
                        <Form.Label>
                            Confirm Password<span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="password"
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            placeholder="Enter confirm Password"
                        />
                    </Form.Group>
                    {Object.keys(errors).length > 0 && (
                        <div className="mt-2">
                            <ul>
                                {Object.values(errors).map((error, index) => (
                                    <React.Fragment key={index}>
                                        {!!error && (
                                            <li>
                                                <Form.Text className="text-danger">{error}</Form.Text>
                                            </li>
                                        )}
                                    </React.Fragment>
                                ))}
                            </ul>
                        </div>
                    )}
                    <div className={`d-grid ${errors?.standardError ? "mt-1" : "mt-4"}`}>
                        <Button
                            className="btn-sm"
                            type="submit"
                            variant="primary">
                            Submit
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default CompleteRegistration
